exports = module.exports = require("../../node_modules/.pnpm/css-loader@0.28.11/node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".container-accordion[data-v-f3fbb060]{transition:all .4s ease-in-out;position:relative;overflow-y:hidden}.container-open[data-v-f3fbb060]{max-height:900px}div[data-v-f3fbb060]::-webkit-scrollbar{display:none;width:0}div[data-v-f3fbb060]::-webkit-scrollbar-track{background:transparent}.container-close[data-v-f3fbb060]{overflow-y:hidden;max-height:80px}.accordion[data-v-f3fbb060]{transition:opacity .4s linear;transition-delay:.3s}.open[data-v-f3fbb060]{opacity:1%}.close[data-v-f3fbb060]{opacity:0}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/.pnpm/css-loader@0.28.11/node_modules/css-loader?minimize!./node_modules/.pnpm/vue-loader@13.7.3_babel-core@6.26.3_css-loader@0.28.11_vue-template-compiler@2.7.16_webpack@3.12.0/node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-f3fbb060","scoped":true,"hasInlineConfig":false}!./node_modules/.pnpm/vue-loader@13.7.3_babel-core@6.26.3_css-loader@0.28.11_vue-template-compiler@2.7.16_webpack@3.12.0/node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/forms-loja/config-pagonline-form-loja.vue
// module id = 1931
// module chunks = 0